import React from 'react';
import { translate } from '../Services/translation';
import { useDispatch } from 'react-redux';
import { setCategoryTabOpen } from "../Actions/FacetedSearch.action";
import { Svg } from './Svg';


const CategoryTriggerButton = () => {
    const dispatch = useDispatch();
    return (
        <button onClick={() => dispatch(setCategoryTabOpen(true))} className="filter-button button">
            {translate("nmas.navigation.home.title")} <Svg icon="filter"/>
        </button>
    );
};

export default CategoryTriggerButton;